VLW.MenuFull = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		this.trigger    = document.querySelector("._menuTrigger");
		this.close      = this.elt.querySelector("._close");
		this.closes      = this.elt.querySelectorAll("._close");
		this.background = this.elt.querySelector("._background");
		this.menu       = this.elt.querySelector("._menu");
		this.video      = this.elt.querySelector("._video");
		this.lisMenu    = [...this.elt.querySelectorAll("._menu li")];
		this.weeChat 	= this.elt.querySelector("._RS_wechat");
		this.popupWeeChat =  this.elt.querySelector(".wechat-modal");
		this.closeWeeChat =  this.popupWeeChat.querySelector(".wechat-modal-close");
		this._display   = false;
		this.trigger	.addEventListener("click"	, this.onClickTrigger);
		this.close		.addEventListener("click"		, this.onClickClose);
		this.close		.addEventListener("mouseenter"	, this.onEnterClose);
		this.close		.addEventListener("mouseleave"	, this.onLeaveClose);
		this.elt		.addEventListener("click"		, this.onClickClose);


		broadCaster.INTROMENU.add(this.onIntroDispatch);
		this.lisMenu.forEach((elt=>{
			if(!elt.classList.contains("_background")) {
				elt.addEventListener("mouseenter", this.onEnterLiMenu);
				elt.addEventListener("mouseleave", this.onLeaveLiMenu);
				elt.vlwIdleChars  = new SplitText(elt.querySelector("a ._idle"), {type: "words,chars", charsClass: "char"}).chars;
				elt.vlwHoverChars = new SplitText(elt.querySelector("a ._hover"), {type: "words,chars", charsClass: "char"}).chars;
			}
		}));
		BUREAU_ONLY===true && document.addEventListener("mousemove"	, this.onMousemove	, supportsPassive);
		window.addEventListener("resize", this.onResize);
		this.preloadHandler(this.onLoadBackgrounImage	,"data-style-background")(this.elt.querySelector("._background"));
		this.newsletter 	= new VLW.Newsletter(this.elt.querySelector("form[name='NEWSLETTER']"));
		this.divNewsletter 	= this.elt.querySelector("._newsletter");
		this.divNewsletter.addEventListener("click",this.onClickNewsletterDiv);
		this.video.addEventListener("click",this.onClickVideo);
        this.weeChat.addEventListener("click", this.onClickWeeChat);
    }

    onClickWeeChat(e){
        e.preventDefault();
        e.stopPropagation();
        this.popupWeeChatDisplay();
        this.closeWeeChat.addEventListener('click', this.onClickCloseWeeChat);
        this.popupWeeChat.addEventListener('click', this.onClickCloseWeeChat);
    }

    onClickCloseWeeChat(e){
        e.preventDefault();
        e.stopPropagation();
        this.popupWeeChatHide();
    }

	onClickVideo(){
		SITE_VIDEO.display();
	}

	onClickNewsletterDiv(e){
		e.stopPropagation();
	}
	preloadHandler(callBack,attribute){
		return (e)=>{
			let img    = new Image();
			img.elt    = e;
			img.onload = callBack;
			img.src    = e.getAttribute(attribute);
		}
	}

	onLoadBackgrounImage(e){
		e.currentTarget.elt.style.backgroundImage = "url(" + e.currentTarget.src + ")";
		e.currentTarget.elt.classList.add("_backgroundImageLoaded");
		e.currentTarget.elt = null;
	}

	onResize(){
		TweenMax.set(this.elt,  {clip: "rect(0px "+getDocSize().width+"px "+getDocSize().height+"px 0px)"});

	}
	onIntroDispatch(){
		TweenMax.fromTo(this.trigger,1.5,{opacity:0},{opacity:1,ease:Power2.easeInOut});
		TweenMax.fromTo(this.trigger.querySelector("ul"),1.5,{opacity:0},{opacity:1,ease:Power2.easeInOut});

	}
	onEnterClose(){
		TweenMax.to(this.background,.75,{opacity:.75});
		TweenMax.to(this.elt.querySelectorAll("a,footer,._newsletter,._menu"),.75,{opacity:0});
		TweenMax.to(this.close.querySelector("svg"),.5,{scale:.5});

	}
	onLeaveClose(){
		TweenMax.to(this.background,.5,{opacity:1});
		TweenMax.to(this.elt.querySelectorAll("a,footer,._menu"),.75,{opacity:1});
		TweenMax.to(this.close.querySelector("svg"),.5,{scale:1});
	}
	getDirection(x1, y1, x2, y2) {
		// might be negative:
		var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
		// correct, positive angle:
		return (angle + 360) % 360;
	}

	onMousemove(e){
		let _m = {x:getDocSize().width*.5-window.mousePosition.x,y:getDocSize().height*.5-window.mousePosition.y};
		let _c = {x:getDocSize().width*.5,y:getDocSize().height*.5};

		let _x = 50+50*window.mousePosition.rationMiddle.x;
		let _y = 50+150*window.mousePosition.rationMiddle.y;

		//TweenMax.to(this.menu,.5,{perspectiveOrigin:_x+"% "+_y+"%"});
        TweenMax.to(this.close		,.5,{x: 0+-5*window.mousePosition.rationMiddle.x	,y:0+-5*window.mousePosition.rationMiddle.y,roundProps:{x:.1,y:.1}});
        TweenMax.to(this.closes		,.5,{x: 0+-5*window.mousePosition.rationMiddle.x	,y:0+-5*window.mousePosition.rationMiddle.y,roundProps:{x:.1,y:.1}});
		TweenMax.to(this.background	,.5,{x: 0+-7*window.mousePosition.rationMiddle.x	,y:0+7*window.mousePosition.rationMiddle.y,roundProps:{x:.1,y:.1}});
	}

	onEnterLiMenu(e){
		TweenMax.killTweensOf(e.currentTarget.vlwIdleChars);
		TweenMax.killTweensOf(e.currentTarget.vlwHoverChars);
		TweenMax.staggerTo(e.currentTarget.vlwIdleChars			,.5,{opacity:0,ease:Sine.easeOut},.0);
		TweenMax.staggerTo(e.currentTarget.vlwIdleChars			,.5,{cycle:{y:[-2,2]}},.01);
		TweenMax.staggerFromTo(e.currentTarget.vlwHoverChars	,1,{cycle:{x:[-2,2]}},{opacity:1,y:0,x:0,delay:.2},.05);

	}
	onLeaveLiMenu(e){
		TweenMax.killTweensOf(e.currentTarget.vlwIdleChars);
		TweenMax.killTweensOf(e.currentTarget.vlwHoverChars);

		TweenMax.staggerFromTo(e.currentTarget.vlwIdleChars		,.75,{cycle:{x:[0,0],y:[0,0]}},{opacity:1,x:0,y:0,ease:Sine.easeIn,delay:.5},.0);
		TweenMax.staggerTo(e.currentTarget.vlwHoverChars		,.75,{opacity:0,cycle:{y:[0,0]}},.01);
	}

	get display() {
		return this._display;
	}

	set display(value) {
		this._display = value;
		this.isDisplay ? this.animDisplay() : this.animHide();
	}

	onClickClose(e) {
		this.display = false;
	}

	onClickTrigger(e) {
		!this.isDisplay ? this.animDisplay() : this.animHide();
	}

	animDisplay() {
		let _yT= getDocSize().height*.0;
		let _yB= getDocSize().height*.95;
		let _xL= getDocSize().width*.05;
		let _xR= getDocSize().width*.95;



		this.tlDisplay = new TimelineMax({paused:true});
		this.tlDisplay.fromTo(this.elt, 1.75,{transformPerspective:800,rotationX:0,y:0}, {force3D:true,y:0,clearProps:"transform",opacity: 1,rotationX:0, pointerEvents: "auto", ease: Power2.easeOut},0);
		this.tlDisplay.set(this.elt,{clearProps:"display"},0);
		VERSION_BUREAU && this.tlDisplay.set(this.background,{transformOrigin:"50% 50%"},0);
		VERSION_BUREAU && this.tlDisplay.fromTo(this.background, 1.25,{opacity:0}, {opacity: 1,ease: Sine.easeInOu},0);
		VERSION_BUREAU && this.tlDisplay.fromTo(this.background, 1.5,{scale:1.5,rotation:-15}, {scale: 1.1,rotation:0,ease: Sine.easeInOut},0);
		this.tlDisplay.fromTo(this.elt, 1, {y: -50}, {y: 0, ease: Sine.easeInOut, delay: 0},0);
		this.tlDisplay.fromTo(this.elt.querySelectorAll("._extranet,._blog")		, 1.5, {y: -50}				, {y: 0, ease: Power2.easeOut, delay: .5}				,0);
		this.tlDisplay.fromTo(this.elt.querySelectorAll("._newsletter,footer,._authBouteille")	, 1.5, {y: 100,opacity:0}	, {y: 0,opacity:1, ease: Power2.easeOut}				,1);
		this.tlDisplay.fromTo(this.elt.querySelectorAll("._vignobles,._extranet")				, 1.5, {y: 50,opacity:0}	, {y: 0,opacity:1, ease: Power2.easeOut}		,1);

		//this.tlDisplay.fromTo(this.elt.querySelectorAll("._menu li")			, 1, {y: 50}, {y: 0, ease: Sine.easeInOut, delay: 0},0);
		//this.tlDisplay.staggerFromTo(this.elt.querySelectorAll("._menu li")		, 1, {opacity:0}, {opacity:1, ease: Sine.easeInOut},.1,.75);
		this.elt.querySelectorAll("._menu li ._idle").forEach((elt)=>{
			this.tlDisplay.staggerFromTo(elt.querySelectorAll(".char"), 1	, {opacity:0}						, {force3D:true,opacity:1	, ease: Sine.easeIn}	,.1	,VERSION_BUREAU?.25:0);
			this.tlDisplay.staggerFromTo(elt.querySelectorAll(".char"), 1.5	, {cycle:{x:(i)=>{return 170}}}		, {force3D:true,x:0,y:0	, ease: Power2.easeOut}		,.05,VERSION_BUREAU?.25:0);

		});
		VERSION_BUREAU && this.tlDisplay.fromTo(this.elt, 1.5, {clip: "rect(" + _yT + "px " + _xR + "px " + _yB + "px " + _xL + "px)"}, {clip: "rect(0px "+getDocSize().width+"px "+getDocSize().height+"px 0px)", ease: Sine.easeOut},0);
		this.tlDisplay.play();
	}

	animHide() {
		TweenMax.set(this.elt	, { pointerEvents: "none"});
		TweenMax.to(this.elt	, .75, {opacity: 0,delay:0,display:"none"});
		VERSION_BUREAU && TweenMax.to(this.background, 2.5, {rotation:25,scale:1.8},0);
	}

    popupWeeChatDisplay(){
        VERSION_BUREAU && TweenMax.to(this.popupWeeChat	, 1.75, {opacity: 1,delay:0,pointerEvents:"all"});
    }
    popupWeeChatHide(){
        if(!VERSION_BUREAU) return;
        TweenMax.set(this.popupWeeChat	, { pointerEvents: "none"});
        TweenMax.to(this.popupWeeChat	,  .75, {opacity: 0,delay:0});
    }
};
